throw new Error(`No exports are available from the top-level "@mastra/server" package.

Use specific subpath imports instead, e.g. "@mastra/server/handlers" or "@mastra/server/handlers/tools".`);
